import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const getIsDemoMode = (flowAPI: ControllerFlowAPI) =>
  flowAPI.environment.isEditor || flowAPI.environment.isPreview;
